import { Popover } from 'evergreen-ui'

import HudGutter from '~/components/HudGutter'
import Tool from '~/components/Tool'
import ToolGroup from '~/components/ToolGroup'
import { MenuIcon } from '~/icons/evergreen'

export default function DockMenuPopover() {
  return (
    <Popover content={<HudGutter className="popover-hud-gutter" />}>
      <div>
        <ToolGroup isHiddenDesktop>
          <Tool active={false} iconBefore={<MenuIcon />} />
        </ToolGroup>
      </div>
    </Popover>
  )
}
